var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindAProviderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paaqhjwj7a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.516 19.957h-7.058v-6.998h-10.85v6.998h-7.059v10.885h7.059v6.998h10.85v-6.998h7.058V19.957z",
    fill: "#F2B543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.516 46.264 12.026 11.922c2.353 2.332 6.275 2.332 8.759 0 2.353-2.333 2.353-6.22 0-8.683L46.405 37.711c-1.046 1.684-2.222 3.11-3.53 4.535-1.699 1.685-3.529 2.98-5.359 4.017z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.62 50.67c-6.666 0-13.202-2.592-18.038-7.387C2.614 38.488 0 32.138 0 25.4 0 18.53 2.614 12.18 7.451 7.387c9.935-9.85 26.144-9.85 36.21 0 8.365 8.293 9.934 20.993 3.79 31.101-1.046 1.814-2.353 3.37-3.79 4.795-1.57 1.555-3.53 2.98-5.491 4.147-3.922 2.203-8.235 3.24-12.55 3.24zm0-48.078c-5.881 0-11.764 2.203-16.208 6.609C4.967 13.607 2.614 19.309 2.614 25.4c0 6.09 2.353 11.792 6.667 16.069 7.19 7.127 18.562 8.682 27.451 3.758a23.756 23.756 0 0 0 4.967-3.758c1.308-1.296 2.353-2.722 3.399-4.277 5.49-8.942 4.052-20.475-3.399-27.862-4.313-4.535-10.196-6.738-16.078-6.738z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paaqhjwj7a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindAProviderIcon);
export default __webpack_public_path__ + "static/media/find-a-provider-icon.297e6845186555975c55b92141a573c5.svg";
export { ForwardRef as ReactComponent };